import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    stage: checkRequiredText(settings),
    lawSector: checkRequiredText(settings),
});

export const AreaOfDeploymentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formStage">
                <Form.Label>Für welche Station bewirbst Du Dich?*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Station eingeben"
                    type="text"
                    name="stage"
                    value={values.stage}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.stage && !errors.stage}
                    isInvalid={touched.stage && errors.stage}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.stage}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formLawSector">
                <Form.Label>Für welche(n) Rechtsbereich(e) interessierst Du Dich besonders?*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Rechtsbereich(e) eingeben"
                    type="text"
                    name="lawSector"
                    value={values.lawSector}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.lawSector && !errors.lawSector}
                    isInvalid={touched.lawSector && errors.lawSector}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.lawSector}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};